import { Component, ElementRef, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef, AfterViewInit, Directive, HostBinding, HostListener } from '@angular/core';
import { DemoService } from '../../../demo.service';

import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor, Query, ReturnOption, DataUtil } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import { IFilter } from '@syncfusion/ej2-angular-grids';
import {
  GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
  RowDataBoundEventArgs
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';

import { Project } from './../../../shared/models/project';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';

// vis.js // also so header scripts included in index.html
// ::  @https://stackblitz.com/edit/bootstrap-ngx-alert-visjf-demo-tpwjcl?file=app%2Fapp%2Fvistimeline%2Fvistimeline.component.ts for a demo and working versions.
declare var vis: any;

// Start using app directives
// :: @ https://www.tektutorialshub.com/angular/hostbinding-and-hostlistener-in-angular/

import { HotToastService } from '@ngneat/hot-toast';
import { Observable} from 'rxjs/internal/Observable';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-projects-grid',
  templateUrl: './projects-grid.component.html',
  styleUrls: ['./projects-grid.component.scss']
})
export class ProjectsGridComponent implements OnInit {

// :: hostbinding
@Directive({
  selector: '[appHighLight]',
})


@HostBinding('style.border') border: string;
loadComponent: boolean;


  @Input() job_id: number;
  @Input() brand_id?: number;
  @Input() job_status_code?: any;
  @Input() assigned_agent?: any; // single agent brand_id lookup

  // passed Values.
  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes. // Base set to Job_ID
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id

  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?= null;
  @Input() item_brand_id?= null;
  @Input() item_subject_id?= null;
  @Input() item_subject_number?= '';

  @Input() show_buttons?= 'no'; // yes | no
  @Input() item_title?= '';
  @Input() widget_size?= 'side'; // side | abstract | full


  @Input() file_number?: any; // subject file number
  @Input() subject_number?: any; // subject file number
  @Input() brand_type_id?: any; // subject file number
  @Input() reference_number?; any;

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  all_router_details: string;
  projects: any;
  projects_data: any;
  modalRef: any;
  count: any;
  initialCount: any;


// access modeil template
@ViewChild('templateCreate') templateCreate: TemplateRef<HTMLDivElement>;


// ngx-vis




// vis.js

@ViewChild('visjsTimeline') timelineContainer: ElementRef;
tlContainer: any;
timeline: any;
dataVis: any;
options: {};
  timelineData: any = [];

  constructor(    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService,
     public datepipe: DatePipe,
    ) {

      // this.toastr.setRootViewContainerRef(vcr);
      // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
     this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

// vis.js load the data
this.getTimelineData();
this.projects_data = new Project();
this.getProjects();
  }


// Hostbiding
// @HostListener('mouseover')
// onMouseOver() {
// //  this.border = '5px solid green';
//   console.log('Mouse over');
//   // this.openModalScript(32);
// }

// @HostListener('mouseleave')
// onMouseLeave() {
// //  this.border = '';
//   console.log('Mouse Leave');
// }

// Opens The Project View Modal
@HostListener('click', ['$event'])
  onclick(event) {
    let target = event.target || event.srcElement || event.currentTarget;
    let idAttr = target.attributes.id;

    if (idAttr.nodeValue){
    let value = idAttr.nodeValue;
    this.loadComponent = true; // show hidden div component
    
    // this.openModalScript(value);
    } // end if node value
  }

// loads and hides div component
  loadMyChildComponent() {
    this.loadComponent = true;
  }
  
  closeMyChildComponent() {
    this.loadComponent = false;
  }
  




// vis.js
  ngAfterViewInit() {
    this.tlContainer = this.timelineContainer.nativeElement;
    // timelineData
    // this.timeline = new vis.Timeline(this.tlContainer, this.dataVis,
    this.timeline = new vis.Timeline(this.tlContainer, this.dataVis,
    {
        width: '100%',
        height: '350px',
        // align: 'left',
        start: '2000-01-01',
        end: '2023-01-01',
        // horizontalScroll: true,
        // rtl: false,
//         template: function (item) {

// // tslint:disable-next-line:max-line-length
// let default_template = '<div style"max-width: 200px;" class="panel panel-default"><div class="panel-heading">' + item.content + '</div><div class="panel-body"<p>' + item.description + '</p></div></div>';
// //  return '<h5>' + item.content + '</h5><p>' + item.description + '</p>';
// // tslint:disable-next-line:max-line-length
// let widget_template = '<div class="widget-head-color-box navy-bg p-lg text-center"><div class="m-b-md"><h2 class="font-bold no-margins">' + item.content + '</h2><small>' + item.description + '</small></div><img src="" class="img-circle circle-border m-b-md" alt=""><div><span>100 Skills</span> | <span>350 Following</span> | <span>610 Followers</span> </div> </div>'

// return widget_template;
//         },
        // start: new Date(2000, 7, 15),
       // end: new Date(new Date().getTime() + 1000000),
        // start: '2000-01-01',
        // end: '2029-01-01',
        // rollingMode: {
        //   follow: true,
        //   offset: .5,
        // },
     
      }
      );


    // click function example on timeline listner.
  //   this.timeline.on('click', function (properties) {
  // //  alert('selected items: ' + properties.item);
  //   openModalScript(properties.itemd);   // I wrote this as a function outside the constructor. see if this works. (javascript reference to a typescript function)
  //   goBack();

  //    console.log(properties.items);
  //   });

    // this.timeline.on('select', this.openModalScript(32));


    
  }



  redrawTimeLine(){
    this.timeline.redraw();
  }
  rollingModeTimeLine(){
    this.timeline.toggleRollingMode();
  }

  getTimelineData() {
    // Create a DataSet (allows two way data-binding)
    this.dataVis = new vis.DataSet([
    //   {id: 1, content: 'Software Development Contract', start: '2018-04-20', title: 'Sharmans Office Portal - SOP', className: 'mybox', type: 'point',},
    //   {id: 2, content: 'Angular Developer (3 Month Contract)', start: '2018-04-14', title: 'Akuety Software - NDIS Systems Australia'},
    //   // tslint:disable-next-line:max-line-length
    //   {id: 3, content: '<div class="widget-head-color-box navy-bg p-lg text-center"><div class="m-b-md"><h2 class="font-bold no-margins">Alex Smith</h2><small>Founder of Groupeq</small></div><img src="" class="img-circle circle-border m-b-md" alt="profile"><div><span>100 Tweets</span> | <span>350 Following</span> | <span>610 Followers</span> </div> </div>', start: '2018-04-18',  type: 'point',},


    //   {id: 4, content: 'exam 4', start: '2018-04-16', end: '2019-04-19', type: 'range', className: 'red'},
    //   {id: 5, content: 'exam 5', start: '2018-04-25', style: 'color: red; background-color: pink;'},
    //   // tslint:disable-next-line:max-line-length
    //   {id: 6, content: '<div class="label label-primary">Skilled Up - Node JS!</div>', start: '2018-04-27', type: 'point', },

    // // Optional: fields 'id', 'type', 'group', 'className', 'style'
    // // type: Can be 'box' (default), 'point', 'range', or 'background'.

    //   // {id: 7, content: 'exam 1', start: '2018-05-01'},
    //   // {id: 8, content: 'exam 2', start: '2018-05-05'},
    //   // {id: 9, content: 'exam 3', start: '2018-05-12'},
    //   // {id: 10, content: 'exam 4', start: '2018-05-15', end: '2013-04-19'},
    //   // {id: 11, content: 'exam 5', start: '2018-05-25'},
    //   // {id: 12, content: 'exam 6', start: '2018-05-27'},
      
    ]);
    
  
    this.options = {
      width: '100%',
      height: '540px',
      editable: true,
      showTooltips: true,
      tooltip: {
        followMouse: true,
        overflowMethod: 'cap'
      },
      margin: {
        item: 20,
        axis: 40
      },
      // start: '2000-01-01',
      //   end: '2029-01-01',
      // rollingMode: {
      //   follow: true,
      //   offset: 0.5
      // }
    };
    // Configuration for the Timeline
    // this.options = {
    //   width: '100%',
    //   height: '320px',
    //   margin: {
    //     item: 25
    //   }
    // };
    // Template Config Setup.
    // this.options = {
    //   template: function (item, element, data) {
    //     return '<h1>' + item.header + data.moving?' '+ data.start:'' + '</h1><p>' + item.description + '</p>';
    //   },
    //   onMoving: function (item, callback) {
    //     item.moving = true;
    //   }
    // };

}



  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
     this.job_id = changes.item_id.currentValue;
    
     // Load different quieries based on if agent associated
     if (this.gfunc.current_base_route === '/agent/jobs/view-job') {
      // only show the subjects if the agent is associated quiery.
    //  this.getAssignedAgentsJobsSubjectsGrid(this.job_id, this.brand_id, this.job_status_code, this.assigned_agent);
    } else {
      // Standard and works for all users except agents
     // this.getJobsTableDataSubjects(this.job_id);
    }




    // Grid Options
     this.toolbarOptions = ['ExcelExport', 'Search'];
    // this.toolbarOptions = []; // none
    this.initialPage = { pageSize: 5 };
    this.filterOptions = {
      type: 'Menu'
    };
   // this.groupOptions = { columns: ['file_number'] }; // sets auto grouping for the grid
    this.groupOptions = { }; // sets auto grouping for the grid
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' }] };


    // end date filter options
    // End Grid Options
    
    }

    }









  ngOnInit() {
// this.projects_data = new Project();
// this.getProjects();

// this.tlContainer = this.timelineContainer.nativeElement;
// this.timeline = new vis.Timeline(this.tlContainer, this.dataVis, {});
// this.openModalScript(32);





  }


  // Setup the SyncFusion GRID


  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
    }
  }



  jobLink(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }

  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  subjectEdit(subject_id) {
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }


  refreshGrid() { // refresh the databutton
    // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);

    // if (this.gfunc.current_base_route === '/agent/jobs/view-job') {
    //   // only show the subjects if the agent is associated quiery.
    //   this.getAssignedAgentsJobsSubjectsGrid(this.job_id, this.brand_id, this.job_status_code, this.assigned_agent);
    // } else {
    //   // Standard and works for all users except agents
    //   this.getJobsTableDataSubjects(this.job_id);
    // }
    this.getProjects();
    this.grid.refresh();
  };



  getProjects() {
    // first clear the array
    this.timelineData = [];
    this._demoService.getProjects().subscribe(
      data => {
        this.projects = data;
        let res = data[0]
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.projects_data = DataUtil.parse.parseJson(data);

// :: TO A loop of details below.

let newArr = data
let  count_of_items = Object.keys(newArr).length;
//  let res = data[0];
 // Run the job data queries.
 // need to do a loop of subject_billing items (.length)
 for(let i=0;i < count_of_items; i++) {
  let res = newArr[i];

  this.timelineData.push({
    id: res.project_id,
    title: res.project_name, // tooltip
    // tslint:disable-next-line:max-line-length
    content: '<div  class="inside-item-click" id="' + res.project_id + '">' + res.project_name + ' <a  class="btn btn-white btn-xs btn-bitbucket"><i class="fa fa-wrench"  title="Edit "></i></a>' + '</div>',
    start: this.datepipe.transform(res.start_date, 'yyyy-MM-dd'),
    end: this.datepipe.transform(res.end_date, 'yyyy-MM-dd'),
    description: res.project_description,
    type: 'box',
    style: '',
    className: '',
          });
 } // end for loop

// adds the array to the timeline dataSet object
 this.dataVis.clear(this.timelineData);
 this.dataVis.add(this.timelineData);


 // this.dataVis  = new vis.DataSet(this.timelineData);

//  this.dataVis.add([
//   {content: 'item 1 added', start: '2018-04-16'},
//   {content: 'item 2', start: '2020-04-16'},
//   {content: 'item 3', start: '2022-04-16'}
// ]);

      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }



  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }

  getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent) {
    this._demoService.getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

      //  this.grid.showSpinner();

      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
      //  console.log(args.data.items);



      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        // console.log(pdfdata.results);

        // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*   this.search_results = pdfdata;
          this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
          this.toastr.success( "Press Start To Process Que");  */
        // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
    }

    //  this.grid.hideSpinner();

  };


















  getBrandJobsTableData(brand_id) {
    this._demoService.getBrandJobsTableData(brand_id).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }

  getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
    this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // End Grid Items and Setup





 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

 openModalScript(project_id) {
  this.sendTypeID(project_id);
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(this.templateCreate, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


   // to router navigate back
   public goBack() {
    this._location.back();
    }

    sendTypeID(id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.count = id;
      this.initialCount = id;
    // console.log('sending ID:' + this.count);
    
    }



    deleteJobServiceRule(job_service_rule_id) {
      if (confirm('Are you sure you want to delete this Service Rule. It cannot be undone...? ')) {
        this._demoService.deleteJobServiceRule(job_service_rule_id).subscribe(
          data => {
            // refresh the list
          //  this.getTraceAssigned(trace_id);
          this.refreshGrid();
            return true;
          },
          error => {
            console.error('Error removing service rule!');
            // return Observable.throw(error);
          }
       );
        }
      };

}


